var codeHelper = [];
codeHelper.push({ statusCode: 200, cn: "", tw: "", en: "" });
codeHelper.push({
  statusCode: 500,
  cn: "API_系统错误",
  tw: "系统错误",
  en: "系统错误"
});
codeHelper.push({
  statusCode: 600,
  // cn: "参数错误",
  cn: "API_参数错误",
  tw: "系统错误",
  en: "系统错误"
});
codeHelper.push({
  statusCode: 700,
  cn: "API_JSON格式错误",
  tw: "系统错误",
  en: "系统错误"
});
codeHelper.push({
  statusCode: 111010,
  cn: "API不存在",
  tw: "系统错误",
  en: "系统错误"
});
codeHelper.push({
  statusCode: 111020,
  cn: "AUTHORIZED_KEY错误",
  tw: "系统错误",
  en: "系统错误"
});
codeHelper.push({
  statusCode: 111030,
  cn: "资料库无记录",
  tw: "系统错误",
  en: "系统错误"
});
codeHelper.push({
  statusCode: 111040,
  cn: "代理冻结",
  tw: "系统错误",
  en: "系统错误"
});
codeHelper.push({
  statusCode: 111050,
  cn: "IP不允许连线",
  tw: "系统错误",
  en: "系统错误"
});
codeHelper.push({
  statusCode: 111060,
  cn: "时间格式错误",
  tw: "系统错误",
  en: "系统错误"
});
// codeHelper.push({
//   statusCode: 111070,
//   cn: "帐号不存在",
//   tw: "系统错误",
//   en: "系统错误"
// });
// codeHelper.push({
//   statusCode: 111080,
//   cn: "帐号已存在",
//   tw: "系统错误",
//   en: "系统错误"
// });
codeHelper.push({
  statusCode: 111090,
  cn: "帐户已被上锁",
  tw: "系统错误",
  en: "系统错误"
});
codeHelper.push({
  statusCode: 111100,
  cn: "帐户未被上锁",
  tw: "系统错误",
  en: "系统错误"
});
codeHelper.push({
  statusCode: 111110,
  cn: "上锁错误 !",
  tw: "系统错误",
  en: "系统错误"
});
codeHelper.push({
  statusCode: 111120,
  cn: "点数不足!",
  tw: "系统错误",
  en: "系统错误"
});
codeHelper.push({
  statusCode: 111130,
  cn: "交易ID不存在 !",
  tw: "系统错误",
  en: "系统错误"
});
codeHelper.push({
  statusCode: 111140,
  cn: "交易ID已存在",
  tw: "系统错误",
  en: "系统错误"
});
codeHelper.push({
  statusCode: 111150,
  cn: "交易错误 !",
  tw: "系统错误",
  en: "系统错误"
});
codeHelper.push({
  statusCode: 111160,
  cn: "游戏维护中!",
  tw: "系统错误",
  en: "系统错误"
});
codeHelper.push({
  statusCode: 111170,
  cn: "游戏不存在!",
  tw: "系统错误",
  en: "系统错误"
});
codeHelper.push({
  statusCode: 111180,
  cn: "游戏无法开启!",
  tw: "系统错误",
  en: "系统错误"
});
// codeHelper.push({
//   statusCode: 111190,
//   cn: "连线逾时，游戏已中断(Game) !!",
//   tw: "系统错误",
//   en: "系统错误"
// });
codeHelper.push({
  statusCode: 111200,
  cn: "数据处理中",
  tw: "系统错误",
  en: "系统错误"
});
codeHelper.push({
  statusCode: 111210,
  cn: "merchant 已关闭",
  tw: "系统错误",
  en: "系统错误"
});
codeHelper.push({
  statusCode: 111220,
  cn: "HashKey错误",
  tw: "系统错误",
  en: "系统错误"
});
codeHelper.push({
  statusCode: 111230,
  cn: "header not contains agent",
  tw: "系统错误",
  en: "系统错误"
});
codeHelper.push({
  statusCode: 111240,
  cn: "header not contains domain",
  tw: "系统错误",
  en: "系统错误"
});
codeHelper.push({
  statusCode: 111250,
  cn: "注单号不存在",
  tw: "系统错误",
  en: "系统错误"
});
codeHelper.push({
  statusCode: 111260,
  cn: "代理不存在",
  tw: "系统错误",
  en: "系统错误"
});
codeHelper.push({
  statusCode: 191010,
  cn: "找不到代理",
  tw: "系统错误",
  en: "系统错误"
});
codeHelper.push({
  statusCode: 191020,
  cn: "验证错误",
  tw: "系统错误",
  en: "系统错误"
});
codeHelper.push({
  statusCode: 191030,
  cn: "帐号不存在",
  tw: "系统错误",
  en: "系统错误"
});
codeHelper.push({
  statusCode: 191040,
  cn: "帐号权限已关闭",
  tw: "系统错误",
  en: "系统错误"
});
codeHelper.push({
  statusCode: 191050,
  cn: "查询时间范围设定错误",
  tw: "系统错误",
  en: "系统错误"
});
codeHelper.push({
  statusCode: 191060,
  cn: "不符合密码规则",
  tw: "系统错误",
  en: "系统错误"
});
codeHelper.push({
  statusCode: 191070,
  cn: "游戏无法启动",
  tw: "系统错误",
  en: "系统错误"
});
codeHelper.push({
  statusCode: 191080,
  cn: "玩家已存在",
  tw: "系统错误",
  en: "系统错误"
});
export { codeHelper };



// WEBPACK FOOTER //
// ./src/service/responseCode.js